/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ site: NonNullable<unknown> }} Body_Measures_Save_SiteInputs */

const en_us2_body_measures_save_site = /** @type {(inputs: Body_Measures_Save_SiteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Log ${i?.site}`)
};

const pt_br2_body_measures_save_site = /** @type {(inputs: Body_Measures_Save_SiteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registrar ${i?.site}`)
};

const es_419_body_measures_save_site = /** @type {(inputs: Body_Measures_Save_SiteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registrar ${i?.site}`)
};

const pt_pt2_body_measures_save_site = /** @type {(inputs: Body_Measures_Save_SiteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registar ${i?.site}`)
};

const fr_fr2_body_measures_save_site = /** @type {(inputs: Body_Measures_Save_SiteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noter ${i?.site}`)
};

const de_de2_body_measures_save_site = /** @type {(inputs: Body_Measures_Save_SiteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site} eintragen`)
};

const it_it2_body_measures_save_site = /** @type {(inputs: Body_Measures_Save_SiteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registra ${i?.site}`)
};

/**
* | output |
* | --- |
* | "Log {site}" |
*
* @param {Body_Measures_Save_SiteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_save_site = /** @type {((inputs: Body_Measures_Save_SiteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Save_SiteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_save_site(inputs)
	if (locale === "es-419") return es_419_body_measures_save_site(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_save_site(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_save_site(inputs)
	if (locale === "de-DE") return de_de2_body_measures_save_site(inputs)
	if (locale === "it-IT") return it_it2_body_measures_save_site(inputs)
	return en_us2_body_measures_save_site(inputs)
});
export { body_measures_save_site as "body-measures.save_site" }